export default [
  {
    type: 'fathers',
    fathers: [
      {
        id: 1,
        firstname: 'Guillaume',
        lastname: 'Ferron',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'John',
        lastname: 'Doe',
        email: 'get.dat.doe@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'Lore em ipz sum',
        lastname: 'Skywalker asdasdas',
        email: 'iamyourfather@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'fathers',
    fathers: [
      {
        id: 1,
        firstname: 'Troi Badabingbadaboom',
        lastname: 'Torres djss',
        email: 'troi@candybanners.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'Rhaegar',
        lastname: 'Targaryen',
        email: 'asdsadad@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'Ned',
        lastname: 'Stark',
        email: 'adadadsad@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'father',
        created_at: '2019-05-14 17:48:26',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'mothers',
    mothers: [
      {
        id: 3,
        firstname: 'Medium Line',
        lastname: 'Longlinesjdhfhsjh',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 4,
        relationship: 'mother',
        created_at: '2019-05-14 17:53:05',
        updated_at: '2019-05-14 17:53:05'
      },
      {
        id: 2,
        firstname: 'Short',
        lastname: 'Name',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'mother',
        created_at: '2019-05-14 17:49:02',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'Daenerys Stormborn',
        lastname: 'of the House Targaryen',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'mother',
        created_at: '2019-05-14 17:49:02',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'mothers',
    mothers: [
      {
        id: 2,
        firstname: 'Short',
        lastname: 'Name',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'mother',
        created_at: '2019-05-14 17:49:02',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 1,
        firstname: 'Daenerys Stormborn',
        lastname: 'of the House Targaryen',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 2,
        relationship: 'mother',
        created_at: '2019-05-14 17:49:02',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 3,
        firstname: 'Cerseisdsadaslkdajsd',
        lastname: 'Lannister',
        email: 'guillaume.ferron2@gmail.com',
        display: 1,
        donor_id: 4,
        relationship: 'mother',
        created_at: '2019-05-14 17:53:05',
        updated_at: '2019-05-14 17:53:05'
      }
    ]
  },
  {
    type: 'doctors',
    doctors: [
      {
        id: 1,
        firstname: 'Guillaume',
        lastname: 'Ferron',
        display: 1,
        donor_id: 2,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 2,
        firstname: 'Caleb sadwekhfydhsg',
        lastname: 'Banack',
        display: 1,
        donor_id: 3,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 3,
        firstname: 'Maisiee',
        lastname: 'Fuss aaaaaaaa',
        display: 1,
        donor_id: 3,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 4,
        firstname: 'GianLuca',
        lastname: 'Gagliano',
        display: 1,
        donor_id: 4,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'doctors',
    doctors: [
      {
        id: 5,
        firstname: 'Harmony',
        lastname: 'Holder',
        display: 1,
        donor_id: 6,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 6,
        firstname: 'Alexis',
        lastname: 'Iaboni-Scenna',
        display: 1,
        donor_id: 7,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 7,
        firstname: 'Poppy',
        lastname: 'Kavelman',
        display: 1,
        donor_id: 8,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 8,
        firstname: 'Summer',
        lastname: 'Kavelman',
        display: 1,
        donor_id: 9,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'nurses',
    nurses: [
      {
        id: 1,
        firstname: 'Nurse',
        lastname: 'Joy',
        display: 1,
        donor_id: 2,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 2,
        firstname: 'Caleb',
        lastname: 'Banackkkkkkkk',
        display: 1,
        donor_id: 3,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 3,
        firstname: 'Maisieeee',
        lastname: 'Fussssssssss',
        display: 1,
        donor_id: 3,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 4,
        firstname: 'GianLucaaaa',
        lastname: 'Gaglianoooooo',
        display: 1,
        donor_id: 4,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'nurses',
    nurses: [
      {
        id: 5,
        firstname: 'Harmony',
        lastname: 'Holder',
        display: 1,
        donor_id: 6,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 6,
        firstname: 'Alexis',
        lastname: 'Iaboni-Scenna',
        display: 1,
        donor_id: 7,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 7,
        firstname: 'Poppy',
        lastname: 'Kavelman',
        display: 1,
        donor_id: 8,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      },
      {
        id: 8,
        firstname: 'Summer',
        lastname: 'Kavelman',
        display: 1,
        donor_id: 9,
        created_at: '2019-05-14 18:23:56',
        updated_at: '2019-05-14 18:23:56'
      }
    ]
  },
  {
    type: 'premature',
    babies: [
      {
        firstname: 'Benjamin',
        middlename: '',
        lastname: 'Harrissssssssssssss',
        birthday: '2017-10-31 00:00:00',
        baby_theme: 'premature',
        display: 1,
        baby_type: 'premature'
      },
      {
        firstname: 'Dagnyyyyyyyyyy',
        middlename: 'Sarah Louise',
        lastname: 'Shellllll',
        birthday: '2015-01-12 00:00:00',
        baby_theme: 'premature',
        display: 1,
        baby_type: 'premature'
      },
      {
        firstname: 'Elsie',
        middlename: '',
        lastname: 'Martin',
        birthday: '2017-07-08 00:00:00',
        baby_theme: 'premature',
        display: 1,
        baby_type: 'premature'
      },
      {
        firstname: 'GianLuca',
        middlename: '',
        lastname: 'Gaglianoooooo',
        birthday: '2019-02-25 00:00:00',
        baby_theme: 'premature',
        display: 1,
        baby_type: 'premature'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/slides.js